import { render } from "./PlayoutSidebarTabs.vue?vue&type=template&id=6f81bb32"
import script from "./PlayoutSidebarTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutSidebarTabs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutSidebarTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f81bb32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f81bb32', __exports__)) {
    api.reload('6f81bb32', __exports__)
  }
  
  module.hot.accept("./PlayoutSidebarTabs.vue?vue&type=template&id=6f81bb32", () => {
    api.rerender('6f81bb32', render)
  })

}


export default __exports__